import { render, staticRenderFns } from "./ErrorBanner.vue?vue&type=template&id=c1e78c44&scoped=true"
import script from "./ErrorBanner.vue?vue&type=script&lang=js"
export * from "./ErrorBanner.vue?vue&type=script&lang=js"
import style0 from "./ErrorBanner.vue?vue&type=style&index=0&id=c1e78c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e78c44",
  null
  
)

export default component.exports